'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _EnvironmentOutlined = _interopRequireDefault(require('./lib/icons/EnvironmentOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _EnvironmentOutlined;
exports.default = _default;
module.exports = _default;